import script from "./si_results_panel.vue?vue&type=script&setup=true&lang=js"
export * from "./si_results_panel.vue?vue&type=script&setup=true&lang=js"

import "./si_results_panel.vue?vue&type=style&index=0&id=45818cfe&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45818cfe"]])

export default __exports__